/*eslint-disable*/ export const messages = JSON.parse("{\"pill.aria.openFilter\":[\"Öppna filter\"],\"pill.aria.removeFilter\":[\"Ta bort filtret \",[\"label\"]]}");
//# sourceMappingURL=messages.mjs.map